import React, {useEffect, useState} from 'react';
import Page from '../Components/Page';
import {Breadcrumbs} from '../Components/Breadcrumbs';
import PeriodsDropdown from '../Components/Dropdowns/PeriodsDropdown';
import {makeApolloClientCall} from '../../Api/makeApolloApiCall';
import LoadingSpinner from "../Components/LoadingSpinner";
import {makeApiCall} from "../../Api/makeApiCall";
import {ReadinessApiError} from "../Components/ReadinessApiError";
import ReadinessContent from "../Components/ReadinessContent";

const SldReadiness = () => {

    const [periodSelection, setPeriodSelection] = useState(undefined);
    const [priorityRetailers, setPriorityRetailers] = useState(undefined);
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const [alertData, setAlertData] = useState([]);
    const [alertIsLoading, setAlertIsLoading] = useState(undefined);

    useEffect(() => {
        setLoading(true)
        const defaultPeriodQuery = `query {
                getNextPeriodIfExists {
                    periodAbbreviation
                 }
            }`

        Promise.all([
            makeApolloClientCall(defaultPeriodQuery),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/priority_retailers`)
        ]).then((([
            defaultPeriodResults,
            priorityRetailersResults,
         ]) => {
            setPeriodSelection(defaultPeriodResults.getNextPeriodIfExists.periodAbbreviation);
            setPriorityRetailers(priorityRetailersResults.data.map(i => i.retailerId));
        })).finally(() => setLoading(false));

    }, [])

    function handleSubmit() {
        setLoading(true);
        setData(undefined);
        getAlerts()
        makeApolloClientCall(getQuery())
            .then((result) => {
                setLoading(false);
                setData(result);
            })
            .catch((e) => {
                setLoading(false);
                setError(e);
            });
    }

    function getAlerts() {
        makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/opsAlertLogsCountByRetailer/`)
            .then(alertData => {
                setAlertIsLoading(false);
                setAlertData(alertData);
            })
    }

    function getQuery() {
        const period = periodSelection ? `periodAbbreviation:"${periodSelection}"` : '';
        return `
query {
  periodReleaseReadiness(${period}, retailerIds: [${priorityRetailers.join(',')}]) {
    periodAbbreviation
    periodWeeks {endDate}
    accounts {
      retailer {retailerId retailChain}
      isKeyAccount
      isNonMarketRetailer
      isRetailerActive
      issues {issueType week {endDate} count message}
      weeksWithSales {weeksWithData totalExpectedWeeks}
      allOutlets
    }
  }
}
`;
    }

    return (

        <Page name={'Store Insights Readiness'}
              breadCrumbs={<Breadcrumbs items={[{label: 'Store Insights'}, {label: 'Readiness'}]}/>}>
            <div className={'readiness-options'}>
                <PeriodsDropdown
                    id={"periods"}
                    updatePeriod={(value) => setPeriodSelection(value)}
                    selectedPeriod={periodSelection}
                    graphqlQuery={'{ marketPeriodList }'}
                />
                <div>
                    <button disabled={priorityRetailers === undefined}
                            className={'button primary left-margin'}
                            onClick={() => handleSubmit()}>Submit
                    </button>
                </div>
            </div>
            {loading && <LoadingSpinner/>}
            {data && <ReadinessContent data={data}
                                       activeRetailersOnly={undefined}
                                       alertData={alertData}
                                       alertIsLoading={alertIsLoading}/>}
            {error && <ReadinessApiError errorMessage={JSON.stringify(error)}/>}
        </Page>);
}

export default SldReadiness;